import React from 'react';

export const RegexNumber = (e: any) => {
  var key = e.key;
  var regex = /[0-9]|\./;
  if (!regex.test(key)) {
    e.preventDefault();
  }
};


